// extracted by mini-css-extract-plugin
module.exports = {"pageBg":"page-bg_pageBg__1o7aC","black":"page-bg_black__3KkHr","green":"page-bg_green__2X_Ef","imgBgWire":"page-bg_imgBgWire__lRqLZ"};